<div class="patrol-discord-page">
  <a class="back-link" routerLink="/setup">
    <img src="/public/svgs/arrow-left-g.svg" alt="" width="16" height="16" />
    {{ 'app.patrol.communities.backToSources' | translate }}
  </a>

  <div class="page-top">
    <div class="page-header">
      <img
        class="page-header__logo"
        src="/public/logos/discord.svg"
        alt=""
        width="40"
        height="40"
      />
      <div>
        <h1 class="page-title">
          {{ 'app.patrol.discord.cockpit.title' | translate }}
        </h1>
        <p class="page-subtitle">
          {{ 'app.patrol.discord.cockpit.subtitle' | translate }}
        </p>
      </div>
    </div>

  </div>

  <app-patrol-discord-guild-switcher />

  @if (selectedGuild(); as guild) {
    @if (!isGuildConnected()) {
      <section class="connect-hero">
        <div class="connect-hero__copy">
          <h2 class="connect-hero__title">
            {{
              'app.patrol.discord.cockpit.connect.pendingTitle'
                | translate: { name: guild.displayName }
            }}
          </h2>
          <p class="connect-hero__text">
            {{ 'app.patrol.discord.cockpit.connect.pendingText' | translate }}
          </p>
        </div>
        <app-patrol-discord-connect-panel
          [botHealth]="botHealth()"
          [displayName]="guild.displayName"
        />
      </section>
    } @else {
      <nav class="cockpit-tabs" aria-label="Discord cockpit sections">
        @for (tab of tabs; track tab.id) {
          <button
            type="button"
            class="cockpit-tabs__btn"
            [class.cockpit-tabs__btn--active]="activeTab() === tab.id"
            (click)="setTab(tab.id)"
          >
            {{ tab.labelKey | translate }}
          </button>
        }
      </nav>

      <div class="cockpit-panel">
        @switch (activeTab()) {
          @case ('overview') {
            <app-patrol-discord-overview [guild]="guild" [botHealth]="botHealth()" />
          }
          @case ('policies') {
            <app-patrol-discord-policies />
          }
          @case ('activity') {
            <app-patrol-discord-activity />
          }
          @case ('ledger') {
            <app-patrol-discord-moderation-ledger />
          }
          @case ('cases') {
            <app-patrol-discord-case-record />
          }
          @case ('queue') {
            <app-patrol-discord-mod-queue />
          }
        }
      </div>
    }
  }
</div>
